
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';

export default {
  name: 'MarketplaceForProsSection',
  props: {
    className: {
      default: '',
      type: String,
    },
    contentClassName: {
      default: '',
      type: String,
    },
    backgroundImageSrc: {
      default: '',
      type: String,
    },
  },
  computed: {
    sectionClassNames() {
      return new StyleClassNamesBuilder('marketplace-for-pros-section')
        .addClassName(this.className)
        .build();
    },
    contentClassNames() {
      return new StyleClassNamesBuilder('marketplace-for-pros-section__content')
        .addClassName(this.contentClassName)
        .build();
    },
    backgroundImageProp() {
      if (this.backgroundImageSrc) {
        return {
          'background-image': `url(${this.backgroundImageSrc})`,
        };
      }

      return null;
    },
  },
};
